<template>
  <div>
    <v-form>
<v-flex xs12 sm12 md12 pa-1>
          <v-card class="white--text">
            <v-card flat="">
              <v-card-actions>

      <v-layout row="" wrap="">
        <v-flex xs12 sm12 md6>
          <v-layout justify-space-between column>
            <v-textarea auto-grow outline v-model="val.NotlarBilgileri.Aciklama1" label="Uçan Kişiler"></v-textarea>
            <v-textarea auto-grow outline v-model="val.NotlarBilgileri.Aciklama2" label="Açıklamalar/Notlar"></v-textarea>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md6>
          <v-layout justify-space-between column>
            <v-checkbox label="Anlaşmalı" v-model="val.NotlarBilgileri.Anlasmali" hide-details=""></v-checkbox>
            <v-checkbox label="Esnek Bilet" v-model="val.NotlarBilgileri.Esnek" hide-details=""></v-checkbox>
          </v-layout>
        </v-flex>
      </v-layout>
  </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>


      <v-layout row="" wrap="">
        <v-flex xs12 sm12 md12>
 <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium ">Segmentler</span>
                            </v-card-title>
                          </v-card>


        </v-flex>
      </v-layout>

      <v-layout row wrap>


        <v-flex xs12 sm6 md6 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>
            <v-text-field hide-details="" v-model="val.NotlarBilgileri.Segment1" label="Segment-1"></v-text-field>
            <v-text-field hide-details="" v-model="val.NotlarBilgileri.Segment2" label="Segment-2"></v-text-field>
            <v-text-field hide-details="" v-model="val.NotlarBilgileri.Segment3" label="Segment-3"></v-text-field>
            <v-text-field hide-details="" label="Segment-4" v-model="val.NotlarBilgileri.Segment4"></v-text-field>
            <v-text-field hide-details="" label="Segment-5" v-model="val.NotlarBilgileri.Segment5"></v-text-field>
<parainput :etiket="'Alternatif Tutar1'" v-model="val.NotlarBilgileri.AlternatifTutar1" :autocomplete="'autocomplete'"></parainput>
            <parainput :etiket="'Alternatif Tutar2'" v-model="val.NotlarBilgileri.AlternatifTutar2" :autocomplete="'autocomplete'"></parainput>
            <parainput :etiket="'Alternatif Tutar3'" v-model="val.NotlarBilgileri.AlternatifTutar3" :autocomplete="'autocomplete'"></parainput>




          </v-layout>
       </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>



        <v-flex xs12 sm6 md6 pa-1>
          <v-card class="white--text">
            <v-card  flat="">
              <v-card-actions>
          <v-layout justify-space-between column>
            <v-text-field hide-details="" v-model="val.NotlarBilgileri.RealCode" label="Realised Code"></v-text-field>
            <v-text-field hide-details="" v-model="val.NotlarBilgileri.RefFare" label="Ref Fare"></v-text-field>
            <v-text-field hide-details="" v-model="val.NotlarBilgileri.LowFare" label="Lowest Fare"></v-text-field>
           <tarihim :etiket="'Res.Date'" v-bind:value="val.NotlarBilgileri.DateofRes" v-model="val.NotlarBilgileri.DateofRes"></tarihim>
    <v-text-field hide-details="" disabled="" v-model="val.NotlarBilgileri.RezervasyonID" label="RES ID"></v-text-field>
            <v-text-field hide-details="" disabled="" v-model="val.DigerBilgileri.SiparisID" label="SİP ID"></v-text-field>

          </v-layout>
          </v-card-actions>
            </v-card>
          </v-card>
        </v-flex>



      </v-layout>

    </v-form>
  </div>
</template>

<script>
  import parainput from '@/components/app/customcomp/parainput.vue'
  import tarihim from '../../customcomp/tarihim'



  export default {
    props: ["value"],
    components: {
      parainput,
      tarihim

    },
    computed: {
      val: {
        get: function () {

          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    data() {
      return {

      }
    },

    watch: {

    },
    methods: {


    },


  }
</script>